
import Icon from '@/components/UntitledUI/Icon.vue'
import Tippy from '@/components/common/Tippy.vue'
import Setting from '@/components/Settings/Setting'
import Button from '@/components/UntitledUI/Button.vue'

export default {
    name: 'Tenant',
    components: { Button, Setting, Icon, Tippy },
    data () {
        return {
            form: new this.$vForm(),
            tenant: null
        }
    },
    computed: {
        isLoading () {
            return this.form.busy && !this.tenant
        },
        highlightedOption () {
            return this.$route.query.highlight
        }
    },
    created () {
        this.form.get('/v1/settings/tenant/current')
            .then((res) => {
                this.tenant = res.data ?? null
                this.form.sharedNotes = this.tenant?.options?.sharedNotes ?? false
                this.form.chatting = this.tenant?.options?.chatting ?? false
            })
    },
    methods: {
        save () {
            this.form.patch('/v1/settings/tenant/current')
                .then((res) => {
                    this.tenant = res.data ?? null
                    this.$refs.settings.alert({
                        type: 'success',
                        body: this.$t('settings team successfully updated')
                    })
                }).catch((e) => {
                    this.$refs.settings.alert({
                        type: 'danger',
                        body: this.$t('general error')
                    })
                })
        }
    }

}
